import TopXLenders from './TopXLenders.js'

export default {
  TopXLenders,
}
